// Regras de senha — espelham EXATAMENTE o backend (não inventar):
//   Users::PasswordValidator: ≥1 maiúscula, ≥1 minúscula, ≥1 número, ≥1 especial
//   Devise config.password_length = 8..128 → mínimo de 8
// O regex de caractere especial é o mesmo do validator do backend.
export const SPECIAL_CHARS_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES = [
  {
    key: "length",
    label: "Pelo menos 8 caracteres",
    test: v => (v || "").length >= PASSWORD_MIN_LENGTH
  },
  {
    key: "upper",
    label: "Uma letra maiúscula",
    test: v => /[A-Z]/.test(v || "")
  },
  {
    key: "lower",
    label: "Uma letra minúscula",
    test: v => /[a-z]/.test(v || "")
  },
  { key: "number", label: "Um número", test: v => /[0-9]/.test(v || "") },
  {
    key: "special",
    label: "Um caractere especial",
    test: v => SPECIAL_CHARS_REGEX.test(v || "")
  }
];

/** Retorna as regras não atendidas por `password` (array vazio = senha válida). */
export function failingPasswordRules(password) {
  return PASSWORD_RULES.filter(rule => !rule.test(password));
}

/** True se a senha cumpre todas as regras do backend. */
export function isPasswordValid(password) {
  return failingPasswordRules(password).length === 0;
}
